<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Please wait...'"></div>
</div>

<div class="starting" *ngIf="isStarting">
  <img src="../../../../assets/img/logo1.svg" alt="" class="img">
</div>

<div *ngIf="!isStarting" class="change-password-page-custom">
  <div class="container-change-password">
    <div>
      <img src="../../../../assets/img/logo2.svg" alt="" class="img">
    </div>
    <div class="pb-5">
      <form #changePasswordForm="ngForm" name="changePasswordForm">

        <div class="form-group pb-3">
          <show-hide-password icon="fa fa-eye-slash" btnStyle="primary" class="inputbotom">
            <input #userPassword="ngModel" ngModel name="userPassword" type="password"
              (keydown.enter)="attemptToChangePassword($event, changePasswordForm)" class="form-control input-underline"
              [attr.placeholder]="'changePassword.password' | translate" required>
          </show-hide-password>
        </div>
        <!-- <div class="error">
          {{error?.message}}
        </div> -->
        <br>
      </form>
      <div class="row col-12">
        <div class="button">
          <button class="btn changePassword_button w-100" (click)="attemptToChangePassword($event, changePasswordForm)" translate>changePassword.changePassword</button>
        </div>
      </div>
    </div>
  </div>
</div>